import {ApiClient, ClientConfig, UpdateConfig} from "../../api/ApiClient";
import React, {useEffect, useState} from "react";
import Title from "@douyinfe/semi-ui/lib/es/typography/title";
import {Button, Form, Row} from "@douyinfe/semi-ui";

export interface ClientConfigProps{
    clientType: string
    title: string
}
const apiClient = ApiClient.getDefault()
const Select = Form.Select;
const { Option } = Select;
export function ClientConfigPage(props: ClientConfigProps){
    let [clientConfig, setClientConfig] = useState<ClientConfig>()
    let [submitting, setSubmitting] = useState(false)
    let [defaultClient, setDefaultClient] = useState<string>()
    useEffect(() => {
        apiClient.getClientConfig(props.clientType)
            .then(r => {
                setClientConfig(r.data)
                setDefaultClient(r.data.defaultClient.value)

            })
    }, [props.clientType])

    let handleFormChange =  (values: Record<string, any>) => {
        let key = clientConfig!.defaultClient.id.toString()
        if(values[key]){
            setDefaultClient(values[key])
        }
    }
    let handleSubmit =  async (values: Record<string, any>) => {
        setSubmitting(true)
        let configs: UpdateConfig[] = Object.keys(values).map(k => {
            return {
                id: parseInt(k),
                value: values[k]
            }
        })
        await apiClient.updateClientConfig(configs)
        setSubmitting(false)
    }

    let getInitValues = ():Record<string, any> => {

        let initValues: Record<string, any> = {}
        initValues[clientConfig!.defaultClient.id.toString()] = clientConfig!.defaultClient.value
        clientConfig?.configs.filter(c => c.clientKey == clientConfig!.defaultClient.value).forEach(c => {
            initValues[c.id] = c.value
        })
        return initValues
    }

    return <div className="client-config-page">
        <div className="client-config-title">
            <Title heading={3}>{props.title}</Title>
        </div>
        <div className="client-config-content">
            {
                !clientConfig ? null :
                    <Form
                        key={clientConfig.defaultClient.key}
                        initValues={getInitValues()}
                        onSubmit={handleSubmit}
                        labelWidth={200}
                        labelPosition="left"
                        labelAlign="right"
                        layout='vertical'
                        onValueChange={handleFormChange}
                    >
                        <Form.Select
                            key={clientConfig.defaultClient.id}
                            style={{ width: 400}}
                            field={clientConfig.defaultClient.id.toString()}
                            label={{ text: clientConfig.defaultClient.description }}
                        >
                            {
                                clientConfig.defaultClient.options.map(o => <Option value={o.key} key={o.key}>{o.label}</Option>)
                            }
                        </Form.Select>
                        {
                            clientConfig.configs.filter(c => c.clientKey == defaultClient).map(c =>
                                <Form.TextArea
                                    rows={3}
                                    style={{ width: 400 }}
                                    helpText={c.description}
                                    key={c.id}
                                    field={c.id.toString()}
                                    label={c.key}
                                />
                            )
                        }
                        <Row>
                            <Button
                                loading={submitting}
                                style={{marginLeft: 200}}
                                type="primary"
                                htmlType="submit"
                                className="btn-margin-right"
                            >
                                保存
                            </Button>
                        </Row>
                    </Form>
            }

        </div>
    </div>
}